import { render, staticRenderFns } from "./BlackWeekTeaser.vue?vue&type=template&id=1e16cdde&scoped=true"
import script from "./BlackWeekTeaser.vue?vue&type=script&lang=js"
export * from "./BlackWeekTeaser.vue?vue&type=script&lang=js"
import style0 from "./BlackWeekTeaser.vue?vue&type=style&index=0&id=1e16cdde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e16cdde",
  null
  
)

export default component.exports